<template>
  <div class="sectionarray" :class="input.extraClass" :style="input.style">

    <div class="headline">
      <span v-on:click="toggleOpenOuter">{{ input.label }}</span><span v-if="outerToggleIsClosed"
                                                                       class="toggleOpenRightArrow"
                                                                       v-on:click="toggleOpenOuter"></span>
      <HelperBox v-if="input.helper" :text="input.helper"></HelperBox>
      <div class="toggleOpenFloat"
           title="open / close"
           v-bind:class="{ 'closed': outerToggleIsClosed }"
           v-on:click="toggleOpenOuter"></div>
    </div>
    <div v-if="input.description" class="description">
      <small>{{ input.description }}</small>
    </div>
    <div class="sort-list" v-sortable="sortOptions" v-if="!outerToggleIsClosed">
      <template v-for="(sectionValue, index) in getNestedValue(formValue, input.value)">
        <div :class="input.grid" :data-sort="index" :data-id="arrayId" class="inner closed"
             v-on:focusin="toggleOpen($event, arrayId, index, true)" v-on:dblclick="toggleOpen($event, arrayId, index)">
          <div class="toggleOpen"
               title="open / close"
               v-on:click="toggleOpen($event, arrayId, index)"
               v-if="showHideIcon(input)"></div>
          <div class="numpadding">
            <span class="number">{{ index + 1 }}</span>
            <span class="delete" v-if="!input.disableDelete ? true : !input.disableDelete"
                  v-on:click="onArrayItemDelete($event, sectionValue, formValue, input.value)"></span>
          </div>
          <template v-for="(sectionInput, index2) in input.forms">

            <template v-if="sectionInput && (isOpen(arrayId, index) || index2 < 3)">
              <template v-if="sectionInput.type === 'section'">
                <Section :input="sectionInput" :formValue="sectionValue"></Section>
              </template>
              <template v-else-if="sectionInput.type === 'sectionarray'">
                <SectionArray :input="sectionInput" :formValue="sectionValue"></SectionArray>
              </template>
              <template v-else-if="sectionInput.type === 'sectionpicker'">
                <SectionPicker :input="sectionInput" :formValue="sectionValue"></SectionPicker>
              </template>
              <template v-else-if="sectionInput.type === 'aggregationtable'">
                <AggregationTable :input="sectionInput" :formValue="sectionValue"></AggregationTable>
              </template>
              <template v-else>
                <InputField :input="sectionInput" :formValue="sectionValue"></InputField>
              </template>
            </template>

          </template>
        </div>
      </template>
    </div>
    <button class="right"
            v-if="!outerToggleIsClosed && typeof(input.buttonText) != 'undefined' && input.buttonText != null && input.buttonText != ''"
            v-on:click="onSectionArrayButtonClick($event, input)">{{ input.buttonText }}
    </button>
  </div>
</template>

<script>
import InputField from "./InputField.vue"
import Section from "./Section.vue"
import AggregationTable from "./AggregationTable.vue"
import SectionPicker from "./SectionPicker.vue"
import HelperBox from "../HelperBox.vue"
import {uuid} from "vue-uuid"
import Sortable from "sortablejs"

export default {
  components: {
    // SectionArray,
    InputField,
    Section,
    SectionPicker,
    HelperBox,
    AggregationTable
  },
  mounted: function () {
    this.outerToggleStartup();
  },
  name: "SectionArray",
  props: {
    input: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      outerToggleIsClosed: false,
      arrayId: uuid.v4(),
      listItems: [],
      sortOrder: [],
      sortEl: null,
      sortOptions: {
        handle: ".numpadding",
        onEnd: this.sortOnEnd,
        forceFallback: true,
        animation: 150,
        easing: "cubic-bezier(1, 0, 0, 1)",
        dataIdAttr: "data-sort",
        filter: ".delete"
      }
    }
  },
  methods: {
    outerToggleStartup() {
      if (typeof (this.input.outerToggleIsClosed) == 'undefined') {
        this.input.outerToggleIsClosed = false;
        return;
      }

      this.outerToggleIsClosed = this.input.outerToggleIsClosed;
    },
    onSectionArrayButtonClick(e, input) {
      e.preventDefault();

      // Build new object based on forms, and append to parent array
      let newObj = {};
      if (input.forms) {
        this.buildNewObjectRecursive(input.forms, newObj)
      }

      let levels = input.value.split(".");
      let curLevel = this.formValue;
      let i = 0;
      while (i < levels.length - 1) {
        curLevel = curLevel[levels[i]];

        if (curLevel === undefined) {
          this.formValue[levels[i]] = {};
          curLevel = this.formValue[levels[i]];
        }

        i++;
      }

      // If new array does not exist, create it
      if (levels.length === 2) {
        if (curLevel[levels[1]] == null) {
          curLevel[levels[1]] = [];
        }
      } else {

      }
      {
        if (curLevel[levels] == null) {
          curLevel[levels] = [];
        }
      }

      curLevel[levels[levels.length - 1]].push(newObj);

      if (this.input.callback)
        this.input.callback(newObj, this.$store.getters.currentVersion().data, this.formValue);

      // Force update when adding new array.. Deep nesting is does not update sometimes
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    buildNewObjectRecursive(forms, obj) {

      forms.forEach((form) => {
        if (this.NullOrUndefined(form)) {
          return; //this is the same as continue as it is per element
        }

        if (form.value) {
          // Merge objects
          let objS = form.value.split(".");
          objS.reverse();

          let list = objS.reduce((prev, current) => (
              {[current]: {...prev}}
          ), {});

          this.mergeDeep(obj, list);

          // Get last merged
          let levels = form.value.split(".");
          let curLevel = obj;
          let i = 0;
          while (i < levels.length - 1) {
            curLevel = curLevel[levels[i]];
            i++;
          }

          // Set type based on type in formbuilder
          if (form.type === "number")
          { 
            curLevel[levels[levels.length - 1]] = (form.minValue || form.minValue === "") ? form.minValue : 0;
          }
          else if (form.type === "sectionarray" ||
              form.type === "typeahead" ||
              form.type === "typeahead-countries" ||
              form.type === "radiolist" ||
              form.type === "aggregationtable")
            curLevel[levels[levels.length - 1]] = [];
          else if (form.type === "checkboxlist")
            curLevel[levels[levels.length - 1]] = {};
          else if (form.type === "select" ||
              form.type === "datalist")
            curLevel[levels[levels.length - 1]] = "";
          else
            curLevel[levels[levels.length - 1]] = "";
        }

        if (form.type === "section") {
          this.buildNewObjectRecursive(form.forms, obj);
        }
      });

    }
    ,
    toggleOpenOuter() {

      this.outerToggleIsClosed = !this.outerToggleIsClosed;
    }
    ,
    toggleOpen(e, id, index, forceOpen = false) {

      let list = e.target.closest(".inner");

      if (list.dataset.id !== id)
        return false;

      if (list.matches(".closed") || forceOpen) {
        list.classList.remove("closed");
        this.setListItemId(id, index, true);
      } else if (e.target.classList.contains("inner") || e.target.classList.contains("toggleOpen")) {
        list.classList.add("closed");
        this.setListItemId(id, index, false);
      }

      // Also open parent if any (used for disabled input fields)
      if (list && list.parentNode && list.parentNode.parentNode) {
        const parent = list.parentNode.parentNode.parentNode;
        if (parent.classList.contains("inner") && (list.matches(".closed") || forceOpen)) {
          parent.classList.remove("closed");
          this.setListItemId(id, index, true);
        }
      }
    },
    isOpen(id, index) {
      let name = this.getListItemId(id, index);
      let item = this.listItems.find(x => x.name === name);
      return item == null ? false : item.isOpen;
    },
    showHideIcon(input) {
      let count = 0;
      for (let form of input.forms) {
        if (this.NullOrUndefined(form))
          continue;

        if (form.type === "guid" || form.type === "hidden") // Ignore guid and hidden
          continue;

        if (form.type === "sectionarray" || form.type === "section") // Do an extra count if section
          count++;

        count++;
      }

      return count > 2;
    },
    setListItemId(id, index, isOpen) {
      let name = this.getListItemId(id, index);
      let oldItem = this.listItems.find(x => x.name == name);

      if (oldItem) {
        oldItem.isOpen = isOpen;
      } else {
        let newItem = {
          name: name,
          isOpen: isOpen
        };

        this.listItems.push(newItem);
      }
    },
    getListItemId(id, index) {
      return id + index;
    },
    onArrayItemDelete(e, item, section, value) {
      if (!confirm("Sure?")) return false;

      let index = this.getNestedValue(section, value).indexOf(item);
      this.getNestedValue(section, value).splice(index, 1);

      if (this.input.callback)
        this.input.callback(item, this.$store.getters.currentVersion().data, this.formValue, true);

      // Autosave
      if (this.$route.name.indexOf("studyEditor") > -1)
        this.$store.dispatch("saveCurrentForecastVersion");
    },
    sortOnEnd(e) {
      let list = this.getNestedValue(this.formValue, this.input.value);

      const movedItem = list.splice(e.oldIndex, 1)[0]
      list.splice(e.newIndex, 0, movedItem)

      let sortOrder = [];
      for (let i = 0; i < list.length; i++)
        sortOrder.push(i)

      Sortable.active.sort(sortOrder);
    }
  }
}
</script>